import { createDomain } from "effector";

const domain = createDomain("create_subscription");

if (process.env.NODE_ENV === "development") {
    import("effector-logger/attach").then((module) => module.attachLogger(domain));
}

export default domain;
